import React from 'react'

import VScroll from '../../../../gd-components/scrolling/custom-v-scroll/v-scroll'
import ModalV4HeaderWhite from "../../../../../app/ui/modal/v4/header-white/v4-header-white"
import SearchInput from "../../../../gd-ui/search/search"
import ErrorBoundary from "../../../../error-boundary"
import SessionCustomField from "../../../../model2/custom-field/session-custom-field"

import ExistingFields from "./existing-fields"
import AddCustomField from "./add-custom-field"

type Props = {
    params      : any

    onSubmit    : func
    onClick     : func
    onClickNew  : func
}

export default class AddExisting extends React.Component<Props> {


    state = {
        searchString: ''
    };

    onClickNew = () => {
        this.props.onClickNew();
    }

    onExistingFieldSelect = (customField: SessionCustomField) => {
        this.props.onSubmit({customFieldId: customField.id});
    }

    onSearchChange = (searchString: string) => {
        this.setState({
            'searchString': searchString
        })
    }

    render() {
        return (
            <div className  = "v4-container placement-middle add-existing"
                 onClick    = {this.props.onClick}
            >
                <ErrorBoundary>
                    <ModalV4HeaderWhite
                        height  = {60}
                        title   = "Add Custom Field"
                    />
                    <div className="main">
                        <VScroll>
                            {this.props.params.notification &&
                                <div className="desc">{this.props.params.notification}</div>}

                            <div className="flex-row-left-center border-box p-l-20 p-r-20 p-b-20">
                                <SearchInput
                                    className   = "w-100p"
                                    value       = {this.state.searchString}
                                    onChange    = {this.onSearchChange}
                                />
                            </div>

                            <ExistingFields
                                project                 = {this.props.params.project}
                                taskType                = {this.props.params.taskType}
                                scope                   = {this.props.params.scope}
                                searchString            = {this.state.searchString}
                                onExistingFieldSelect   = {this.onExistingFieldSelect}
                            />

                            <AddCustomField
                                project     = {this.props.params.project}
                                onClickNew  = {this.onClickNew}
                            />
                        </VScroll>
                    </div>
                </ErrorBoundary>
            </div>
        );
    }
}